import { Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const HamburgerMenuButton = () => (
  <Box
    sx={{
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '64px',
      height: '32px',
      py: '5px',
      px: '15px',
      border: '1px solid #adb5bd',
      borderRadius: '5px',
      fontSize: '1.3rem',
    }}
  >
    <FontAwesomeIcon icon={faBars} />
  </Box>
);

export default HamburgerMenuButton;
